import { __awaiter, __generator } from "tslib";
import { getNewUserState } from './getNewUserState';
export function getTuiNewUserState(identity, officeComponentContext, _featureGates) {
    return __awaiter(this, void 0, void 0, function () {
        var inMockMode;
        return __generator(this, function (_a) {
            inMockMode = false;
            return [2 /*return*/, getNewUserState(identity, officeComponentContext, 'TuiNewUserState', inMockMode, function (isCompleted) { return ({
                    CompletedFirstRun: isCompleted,
                    Version: 3,
                    StepsCompleted: 0,
                }); }, function (legacy) { return legacy; })];
        });
    });
}
//# sourceMappingURL=getTuiNewUserState.js.map